import PropTypes from 'prop-types'
import React from 'react'

const BuyHelpBonifico = ({ helper, show }) => (
  <div className={show ? 'helpguide show' : 'helpguide'}>
    <div className="helpguide__title">
      <i className="icon-close js-close-guide" onClick={helper}></i>
      <h3>
        <strong>
          Completa l'acquisto
          <br />
          in pochi click!
        </strong>
      </h3>
    </div>
    <div className="helpguide__content">
      <div
        className="helpguide__finanziamento js-guide-content active"
        data-guide="finanziamento"
      >
        <div
          className="scroll-wrapper js-guide-scrollbar"
          style={{ position: 'relative' }}
        >
          <div className="js-guide-scrollbar scroll-content scroll-scrolly_visible">
            <h4 className="helpguide__subtitle">
              <span className="hghlght animate">Solo due semplici regole</span>
            </h4>
            <ol className="numbers-list helpguide__list">
              <li>
                <strong>Devi essere residente in Italia</strong>, per acquistare
                (e intestarti) un’auto da brumbrum.
              </li>
              <li>
                <strong>
                  Tutti i tuoi documenti devono essere in corso di validità.
                </strong>
                <ul className="dots-list">
                  <li>
                    Documento d’identità (uno a scelta tra carta d’identità,
                    passaporto o patente)
                  </li>
                  <li>Codice fiscale</li>
                  <li>Permesso di soggiorno (solo per cittadini extra EU)</li>
                </ul>
              </li>
            </ol>

            <h4 className="helpguide__subtitle">
              <span className="hghlght animate">Cosa devi fare?</span>
            </h4>
            <ol className="numbers-list helpguide__list">
              <li>
                <strong>Inserisci i tuoi dati</strong> (anagrafici e residenza)
                e verifica la loro correttezza.
              </li>
              <li>
                <strong>Visualizza la proposta contrattuale</strong> per
                l’acquisto della tua auto
              </li>
              <li>
                <strong>Esegui il bonifico</strong> rivolgendoti alla tua banca
                di fiducia utilizzando l’IBAN di brumbrum S.p.A. indicato sul
                sito.
              </li>
              <li>
                <strong>
                  Inserisci il codice CRO<sup>A</sup> o TRN<sup>B</sup>
                </strong>{' '}
                che puoi trovare sulla ricevuta del bonifico rilasciata dalla
                tua banca.
              </li>
              <li>
                <strong>Mettiti comodo!</strong> Il Servizio Clienti di brumbrum
                ti contatterà per concordare le modalità di consegna o di ritiro
                della tua auto.
              </li>
            </ol>

            <h4 className="helpguide__subtitle">
              In caso di dubbi o se hai bisogno di aiuto non esitare a
              contattare il numero{' '}
              <span className="hghlght animate">02.800.29</span>!<br />
              Il Servizio Clienti brumbrum è sempre pronto a rispondere ad ogni
              tua richiesta dal lunedì al venerdì dalle 9:00 alle 19:00 e il
              sabato dalle 9:00 alle 18:00.
            </h4>

            <p className="helpguide__note">
              <span>
                <sup>A</sup> <strong>Codice Riferimento Operazione</strong>, un
                codice numerico di 11 cifre
              </span>
              <span>
                <sup>B</sup> <strong>Transaction Reference Number</strong>, un
                codice alfanumerico composto da 30 caratteri
              </span>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
)

BuyHelpBonifico.propTypes = {
  helper: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
}

export default BuyHelpBonifico
